<template>
	<v-app-bar app flat class="white">
		<v-app-bar-nav-icon @click="$emit('toggle-drawer')" color="black"></v-app-bar-nav-icon>

		<img src="../../public/pmx_logo_small.png" alt="PMX Logo" class="logo pl-5" />
		<v-toolbar-title class="text-uppercase">
			<span class="font-weight-light grey--text text--darken-2">harma</span>
			<span class="font-weight-medium">Monitor</span>
			<span class="font-weight-light orange--text">Express</span>
		</v-toolbar-title>
		<v-spacer></v-spacer>
		<v-btn icon>
			<Help />
		</v-btn>
		<v-divider vertical class="mx-4" color=""></v-divider>
		<Tooltip />
	</v-app-bar>
</template>

<script>
	import Tooltip from './Tooltip.vue';
	import Help from './Help.vue';

	/**
	 * @module Navbar
	 *
	 * @vue-event {boolean} toggle-drawer - Emit toggle drawer to show/hide it
	 */

	export default {
		components: { Tooltip, Help },
	};
</script>

<style lang="scss" scoped>
	.logo {
		padding-right: 1px;
	}
</style>
